module.exports = __webpack_public_path__ + "static/media/trainer.e0611195.png";